module.exports = __webpack_public_path__ + "static/media/vendorLogo.d106b352.png";